import cn from 'classnames';
import styles from './TabPanels.module.css';

type Props = {
  /** TabPanel elements */
  children: React.ReactNode;
  className?: string;
};

export function TabPanels({ children, className }: Props) {
  return <div className={cn(styles.TabPanels, className)}>{children}</div>;
}
